import { Stierhornschenkelschale } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesWeltErbeMuseumHallstatt({ currentMuseumId }) {
  const { stierhornschenkelschale } = Stierhornschenkelschale();

  const artefactArray = [stierhornschenkelschale];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
